import React from 'react';
import { Box, Skeleton } from '@mui/material';

import LexCard from '_lex/_atoms/LexCard';

const DraftManualCardSkeleton: React.FC = () => (
  <LexCard
    header={
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <Skeleton variant='rounded' width={80} height={24} />
        <Skeleton variant='circular' width={32} height={32} />
      </Box>
    }
    footer={
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <Skeleton variant='rounded' width={140} height={22} />
        <Skeleton variant='rounded' width={90} height={28} />
      </Box>
    }
  >
    <Box sx={{ px: 2, py: 1.5, pb: 3, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Skeleton variant='text' width='70%' height={28} />
      <Skeleton variant='text' width='45%' height={20} />
      <Skeleton variant='text' width='55%' height={20} />
    </Box>
  </LexCard>
);

export default DraftManualCardSkeleton;
